import Vue from "vue";

export default new Vue({
  computed: {
    baseEventName(): string {
      return 'advanced-filter';
    },
    validatedEvent(): string {
      return this.baseEventName + '-validated';
    },
    editedEvent(): string {
      return this.baseEventName + '-edited';
    },
  },
  methods: {
    emitValidated(isValid: boolean): void {
      this.$emit(this.validatedEvent, isValid);
    },
    onValidated(callback: (isValid: boolean) => void): void {
      this.$on(this.validatedEvent, callback);
    },
    emitEdited(): void {
      this.$emit(this.editedEvent);
    },
    onEdited(callback: Function): void {
      this.$on(this.editedEvent, callback);
    },
  },
});